
  import { Vue, Component, Prop } from "vue-property-decorator";
 
  @Component
  export default class Chip extends Vue {
    @Prop({required: true, type: String}) readonly chipContent!: string;

    get contentPresent () {
      return this.chipContent !== ""
    }
  }
